import { isFeatureEnabled, serverData, isFeatureNotEnabled } from '../utils'
import {
  PRIVACY_HOME,
  PRIVACY_MERCHANT_HOME_FROM_DAR,
} from '../constants/constants'
import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { BodyText } from '@paypalcorp/pp-react'
const isMerchantUser = serverData.isMerchantUser
const privacySettingsLink = isMerchantUser
  ? PRIVACY_MERCHANT_HOME_FROM_DAR
  : PRIVACY_HOME
const communicationLink = '/myaccount/privacy/data/notifications/redirect'
const { locality = {},country } = serverData

//classes
const iconClass = `privacy-hub-main-link-icon privacy-hub-card-background-off-white`
const svgCardClass = `privacy_hub_image_icon_container privacy-hub-m-auto`
const privacyHubTextClass = `privacy-hub-text`

const dataSecurityLink = `/${country}/webapps/mpp/paypal-safety-and-security`
const homeSecurityLink = '/myaccount/privacy/data/security/redirect'


// accent classes
const blueIconClass = 'sysColorAccent1Main'

const icon ={
  protectionBlueIcon : 'protection-blue',
  privacyBlueIcon :'privacy-blue',
  dataManagementBlueIcon :'data-managment-blue',
  sendReceiveBlueIcon :'send-receive-blue',
  addCardBlueIcon :'add-card-blue',
  settingsIcon : 'settings',
  emailIcon : 'email',
  resolutionIcon :'resolution',
  viewIcon : 'view',
  termsIcon : 'terms',
  informationIcon : 'information',
  shareIcon : 'share',
  letterCheckmarkIcon : 'letter-checkmark',
  documentIcon : 'document',
  securityIcon : 'security',
};

//links
const privacyPrinciplesLink = '/myaccount/privacy/privacyhub/principles';

//get svg
const getSvgUrl = (name) =>
  `https://${serverData.cdnHostName}/paypal-ui/pictograms/blue/svg/${name}.svg`

const getBannerUrl =(name)=> `https://${serverData.cdnHostName}/privacyhub/${name}.svg`

  const headerSectionConfig ={
    home:{
      banner:{
        url:getBannerUrl('home'),
        alt:'privacyBannerImage'
      },
      icon:{
        url:getSvgUrl(icon.protectionBlueIcon),
        alt:'protectionSvgIcon'
      },
      content:{
        heading:{
          messageId:'privacyhub.home.privacyprinciples.title',
          id:'privacyComesFirst'
        },
        description:{
          messageId:'privacyhub.home.privacyprinciples.desc',
          id:'privacyComesFirst'
        }
      },
      link:{
       name:'privacyHubPrinciples',
       href:privacyPrinciplesLink,
       id:'privacyPrinciplesLink'
      }
    },
    others:{
      banner:{
        url: getBannerUrl('other-people'),
        alt:'otherPeopleBannerImage'
      },
      icon:{
        url:getSvgUrl(icon.privacyBlueIcon),
        alt:'othersSeeSvg'
      },
      content:{
        heading:{
          messageId: 'privacyhub.home.otherssee.title',
          id:"whatOtherPeopleSeeTitle"
        },
        description:{
          messageId: 'privacyhub.home.otherssee.desc',
          id:"whatOtherPeopleSeeDescription"
        }
      },
      link:null
    },
    principles:{
      banner:{
        url:getBannerUrl('privacy-principles'),
        alt:'privacyPrinciplesImage'
      },
      icon:{
        url:getSvgUrl('trust-blue'),
        alt:'privacyPrinciplesSvgIcon'
      },
      content:{
        heading:{
          messageId: 'privacyhub.principles.privacyprinciples.title',
          id:'privacyPrinciplesTitle'
        },
        description:{
          messageId: 'privacyhub.principles.privacyprinciples.desc',
          id:'privacyPrinciplesDescription'
        }
      },
      link:null
    },
    bussinessFaq:{
      banner:{
        url:getBannerUrl('for-businesses'),
        alt:'bussinessBannerImage'
      },
      icon:{
        url:getSvgUrl('businesses-blue'),
        alt:'bussinessBlueSvgIcon'
      },
      content:{
        heading:{
          messageId: 'privacyhub.business.business.title',
          id:'bussinessTitle'
        },
        description:{
          messageId: 'privacyhub.home.business.desc',
          id:'bussinessDescription'
        }
      },
      link:null
    },
    data:{
      banner:{
        url:getBannerUrl('your-data'),
        alt:'howWeUseYourDataBannerImage'
      },
      icon:{
        url:getSvgUrl(icon.dataManagementBlueIcon),
        alt:'dataUsageSvg'
      },
      content:{
        heading:{
          messageId: 'privacyhub.data.banner.title',
          id:"howWeUseYouDataTitle"
        },
        description:{
          messageId: 'privacyhub.data.banner.desc',
          id:"howWeUseYourDataDescription"
        }
      },
      link:null
    }
  }

export const homeConfig = {
  // this section object will be reusable config for most of the sections of the home,privacy-business faq and privacy principles
  section: {
    cols: 6,
    cardClass: '',
    order: 1,
    heading: {
      messageId: 'privacyhub.home.privacyprinciples.title',
      id: 'privacyComesFirst',
      class: 'privacy-hub-display-text',
      size: 'sm',
    },
    Content: '',
    descriptionList: [
      {
        description: {
          messageId: 'privacyhub.home.privacyprinciples.desc',
          id: 'privacyPrinciplesBody',
          class: `privacy-hub-heading-description-section ${privacyHubTextClass}`,
          size: 'md',
        },
        descriptionLink: {
          name: 'privacyHubPrinciples',
          id: 'privacyPrinciplesLink',
          href: privacyPrinciplesLink,
          class: 'privacy-hub-heading-description-link',
          size: 'md',
        },
      },
    ],
    asset: {
      icon_svg_link: false,
      component_icon: false,
      imgSrc: `https://${serverData.cdnHostName}/privacyhub/HomePage.svg`,
      imgClass: `privacy-hub-svg-home-page privacy-hub-display-col-mid height-full`,
      alt: 'homepage',

      svgIconClass: iconClass,
      name: '',
      size: 'md',
      color: '',

      order: 2,
      cols: 6,
    },
  },
  headerSection:(page)=>{
    return {
              icon:{
                className:'header-icon',
                ...headerSectionConfig[page]?.icon,
              },
              banner:{
                className: `privacy-hub-banner`,
                ...headerSectionConfig[page]?.banner
              },
              content:{
                heading:{
                  ...headerSectionConfig[page]?.content?.heading,
                  className: 'privacy-hub-display-text',
                  size: 'hero',
                },
                description:{
                  ...headerSectionConfig[page]?.content?.description,
                  className: `privacy-hub-heading-description-section ${privacyHubTextClass}`,
                  size: 'md',
                },
                link:{
                  className: 'privacy-hub-heading-description-link',
                  size: 'md',
                  ...headerSectionConfig[page]?.link,
                }
              }
           }
  },
  mainLinks: [
    {
      icon: {
        name: icon.settingsIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.home.mainlink.title1',
      description: 'privacyhub.home.mainlink.desc1',
      link: 'privacyhub.home.mainlink.link1',
      href: privacySettingsLink,
      name: 'controlYourPrivacy',
      className: 'privacy-hub-settings',
      id: 'privacyhubHomeSettingsLink',
    },
    {
      icon: {
        name: icon.emailIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.home.mainlink.title2',
      description: 'privacyhub.home.mainlink.desc2',
      link: 'privacyhub.home.mainlink.link2',
      href: communicationLink,
      name: 'manageEmails&Notifications',
      className: 'privacy-hub-email',
      id: 'privacyhubHomeCommunicationLink',
    },
    {
      icon: {
        name: icon.securityIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.home.mainlink.title3',
      description: 'privacyhub.home.mainlink.desc3',
      link: 'privacyhub.home.mainlink.link3',
      href: homeSecurityLink,
      name: 'helpKeepYourAccountSecure',
      className: 'privacy-hub-security',
      id: 'privacyhubHomeSecurityLink',
    },
    {
      icon: {
        name: icon.documentIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.home.mainlink.title4',
      description: 'privacyhub.home.mainlink.desc4',
      link: 'privacyhub.home.mainlink.link4',
      modal: 'privacyRights',
      name: 'knowYourDataRights',
      className: 'privacy-hub-data-rights',
      id: 'privacyhubHomePrivacyRightsLink',
    },
  ],
  othersAndData: [
    {
      svg_icon: {
        class: 'privacy_hub_image_icon_container',
        src: getSvgUrl(icon.privacyBlueIcon),
      },
      key: 'otherssee',
      title: 'privacyhub.home.otherssee.title',
      description: 'privacyhub.home.otherssee.desc',
      link: 'privacyhub.home.otherssee.link',
      href: '/myaccount/privacy/privacyhub/others',
      name: 'whatOtherPeopleSee',
      id: 'privacyHubHomeLearnMore',
    },
    {
      svg_icon: {
        class: 'privacy_hub_image_icon_container',
        src: getSvgUrl(icon.dataManagementBlueIcon),
      },
      key: 'datausage',
      title: 'privacyhub.home.datausage.title',
      description: 'privacyhub.home.datausage.desc',
      link: 'privacyhub.home.datausage.link',
      href: '/myaccount/privacy/privacyhub/data',
      name: 'exampleOfHowWeUseYourData',
      id: 'privacyHubHomeMoreInfo',
    },
  ],
}

export const dataUsageConfig = [
  {
    key: 'payandpaid',
    enabled: true,
    content: {
      title: 'privacyhub.data.payandpaid.title',
      desc: [
        'privacyhub.data.payandpaid.desc1',
        'privacyhub.data.payandpaid.desc2',
      ],
      link: 'privacyhub.data.payandpaid.link',
      href: privacySettingsLink,
      name: 'payAndGetPaid',
      id: 'privacyhubDataSettingsLink',
    },
    image: {
      src: getSvgUrl(icon.sendReceiveBlueIcon),
      alt: 'switch-payments',
      classname: 'privacy-hub-data-payandpaid-image',
    },
  },
  {
    key: 'communicate',
    enabled: true,
    content: {
      title: 'privacyhub.data.communicate.title',
      desc: [
        'privacyhub.data.communicate.desc1',
        'privacyhub.data.communicate.desc2',
      ],
      link: 'privacyhub.data.communicate.link',
      href: communicationLink,
      name: 'communicateWithYou',
      id: 'privacyhubDatacommunicationLink',
    },
    image: {
      src: getSvgUrl('email-blue'),
      alt: 'photo-id',
      classname: 'privacy-hub-data-communicate-image',
    },
  },
  {
    key: 'relavantoffers',
    enabled: isFeatureEnabled('enabledForRelavantOffers'),
    content: {
      title: 'privacyhub.data.offers.title',
      desc: ['privacyhub.data.offers.desc1', 'privacyhub.data.offers.desc2'],
      link: 'privacyhub.data.offers.link',
      href: privacySettingsLink,
      name: 'providePersonalisedOffers',
      id: 'privacyhubDataOffersLink',
    },
    // update image
    image: {
      src: getSvgUrl('discounts-blue'),
      alt: 'deals',
      classname: 'privacy-hub-data-deals-image',
    },
  },
  {
    key: 'personalizedads',
    enabled: isFeatureEnabled('enabledForPersonalizedAds'),
    content: {
      title: 'privacyhub.data.personalizedads.title',
      desc: [
        'privacyhub.data.personalizedads.desc1',
        'privacyhub.data.personalizedads.desc2',
      ],
      link: 'privacyhub.data.personalizedads.link',
      href: privacySettingsLink,
      name: 'providePersonalisedAds',
      id: 'privacyhubDataAdsLink',
    },
    // update image
    image: {
      src: getSvgUrl('announce-blue'),
      alt: 'personalized-ads',
      classname: 'privacy-hub-data-personalizedads-image',
    },
  },
  {
    key: 'protectaccount',
    enabled: true,
    content: {
      title: 'privacyhub.data.protectaccount.title',
      desc: [
        'privacyhub.data.protectaccount.desc1',
        'privacyhub.data.protectaccount.desc2',
      ],
      link: 'privacyhub.data.protectaccount.link',
      href: dataSecurityLink,
      name: 'helpProtectYourAccount',
      id: 'privacuhubDataProtectAccountLink',
    },
    image: {
      src: getSvgUrl(icon.protectionBlueIcon),
      alt: 'protect',
      classname: 'privacy-hub-data-protectaccount-image',
    },
  },
]

export const privacyRightsConfig = [
  {
    key: 'haveaccount',
    title: 'privacyhub.privacyrights.haveaccount.title',
    body: [
      {
        id: 'privacyhub.privacyrights.haveaccount.body1',
      },
      {
        id: 'privacyhub.privacyrights.haveaccount.body2',
      },
    ],
    link: 'privacyhub.privacyrights.haveaccount.link',
    href: PRIVACY_HOME,
    name: 'gotAPayPalAccount',
  },
  {
    key: 'donthaveaccount',
    title: 'dsrLoggedout.hub.title2',
    body: [
      {
        id: 'dsrLoggedout.hub.p3',
      },
    ],
    link: 'dsrLoggedout.privacyrights.donthaveaccount.link',
    href: '/myaccount/privacy/common/pypl',
    name: 'donthaveaccount',
  },
]

export const otherPageConfig = {
  whenYouPayOrGetPaid: [
    {
      enabled: true,
      title: {
        size: 'md',
        class: privacyHubTextClass,
        id: 'sendToSomeTitle',
        messageId: 'privacyhub.home.otherssee.sendToSomeOne.title',
      },
      desc: {
        size: 'md',
        class: 'privacy_hub_card_description',
        id: 'sendToSomeoneDesc',
        messageId: 'privacyhub.home.otherssee.sendToSomeOne.desc',
      },
      lists: [
        'privacyhub.home.otherssee.sendToSomeOne.list1',
        'privacyhub.home.otherssee.sendToSomeOne.list2',
      ],
      content: (
        <BodyText className='individual-item'>
          <Message id="privacyhub.home.otherssee.sendToSomeOne.list3" />
        </BodyText>
      ),
      svg_icon: {
        class: 'privacy_hub_image_icon_container',
        src: getSvgUrl('send-money-blue'),
        alt: 'receiveMoney',
      },
      id: 'sendToSomeOne',
    },
    {
      enabled: true,
      title: {
        size: 'md',
        class: privacyHubTextClass,
        id: 'getPaidTitle',
        messageId: 'privacyhub.home.otherssee.getPaid.title',
      },
      desc: {
        size: 'md',
        class: 'privacy_hub_card_description',
        id: 'getPaidDesc',
        messageId: 'privacyhub.home.otherssee.getPaid.desc',
      },
      lists: [
        'privacyhub.home.otherssee.getPaid.list1',
        'privacyhub.home.otherssee.getPaid.list2',
        'privacyhub.home.otherssee.getPaid.list3',
      ],
      descriptionLink: {
        message: 'privacyhub.home.otherssee.getPaid.link',
        href: privacySettingsLink,
        name: 'manageYourProfilePrivacyAndContacts',
        id: 'getPaidLink',
      },
      svg_icon: {
        class: 'privacy_hub_image_icon_container',
        src: getSvgUrl('receive-money-blue'),
        alt: 'receiveMoney',
      },
      id: 'getPaid',
    },
    {
      enabled: true,
      title: {
        size: 'md',
        class: privacyHubTextClass,
        id: 'askSomeoneTitle',
        messageId: 'privacyhub.home.otherssee.askSomeone.title',
      },
      desc: {
        size: 'md',
        class: 'privacy_hub_card_description',
        id: 'askSomeoneDesc',
        messageId: 'privacyhub.home.otherssee.askSomeone.desc',
      },
      className: 'privacy-hub-ask-someone',
      lists: ['privacyhub.home.otherssee.askSomeone.list1'],
      svg_icon: {
        class: 'privacy_hub_image_icon_container',
        src: getSvgUrl(icon.sendReceiveBlueIcon),
        alt: 'sendReceive',
      },
      id: 'askSomeone',
    },
    {
      enabled: isFeatureEnabled('enabledForPayBills'),
      title: {
        size: 'md',
        class: privacyHubTextClass,
        id: 'payBillsTitle',
        messageId: 'privacyhub.home.otherssee.payBills.title',
      },
      desc: {
        size: 'md',
        class: 'privacy_hub_card_description',
        id: 'payBillsDesc',
        messageId: 'privacyhub.home.otherssee.payBills.desc',
      },
      lists: [
        'privacyhub.home.otherssee.payBills.list1',
        'privacyhub.home.otherssee.payBills.list2',
      ],
      svg_icon: {
        class: 'privacy_hub_image_icon_container',
        src: getSvgUrl('pay-bills-blue'),
        alt: 'payBills',
      },
      id: 'payBills',
    },
    {
      enabled: true,
      title: {
        size: 'md',
        class: privacyHubTextClass,
        id: 'giveToCharityTitle',
        messageId: 'privacyhub.home.otherssee.giveToCharity.title',
      },
      desc: {
        size: 'md',
        class: 'privacy_hub_card_description',
        id: 'giveToCharityDesc',
        messageId: 'privacyhub.home.otherssee.giveToCharity.desc',
      },
      lists: [
        'privacyhub.home.otherssee.giveToCharity.list1',
        'privacyhub.home.otherssee.giveToCharity.list2',
        'privacyhub.home.otherssee.giveToCharity.list3',
      ],
      svg_icon: {
        class: 'privacy_hub_image_icon_container',
        src: getSvgUrl('donate-money-blue'),
        alt: 'donateMoney',
      },
      id: 'giveToCharity',
    },
  ],
  whenYouShopData: {
    enabled: true,
    title: {
      size: 'md',
      class: privacyHubTextClass,
      id: 'buyWithPaypalPhonetitle',
      messageId: 'privacyhub.home.otherssee.buyWithPaypal.desc',
    },
    heading: {
      size: 'lg',
      class: `${privacyHubTextClass} privacy_hub_when_you_shop_heading`,
      id: 'buyWithPaypalDesc',
      messageId: 'privacyhub.home.otherssee.shop',
    },
    lists: [
      'privacyhub.home.otherssee.buyWithPaypal.list1',
      'privacyhub.home.otherssee.buyWithPaypal.phone',
      'privacyhub.home.otherssee.buyWithPaypal.list2',
      'privacyhub.home.otherssee.buyWithPaypal.list3',
    ],
    subHeading: {
      size: 'sm',
      class: `${privacyHubTextClass} privacy-hub-subheading`,
      id: 'buyWithPaypalPhoneHeading',
      messageId: 'privacyhub.home.otherssee.buyWithPaypal.title',
    },
    svg_icon: {
      class: `privacy_hub_image_icon_container`,
      src: getSvgUrl('seller-protection-blue'),
      alt: 'privacy-hub-other-buywithpaypal-image',
    },
    id: 'buyWithPaypal',
  },
  LinkBanksAndCardsData: [
    //Gobal
    {
      enabled: isFeatureNotEnabled('disabledAddBankCardsGlobal'),
      subHeading: {
        size: 'sm',
        class: `${privacyHubTextClass} privacy-hub-subheading`,
        id: 'addBankCardsTitle',
        messageId: 'privacyhub.home.otherssee.addBanksCards.title',
      },
      heading: {
        size: 'lg',
        class: `${privacyHubTextClass} privacy-hub-card-heading`,
        id: 'addBankCardsTitle',
        messageId: 'privacyhub.home.otherssee.linkBank',
      },
      lists: [
        'privacyhub.home.otherssee.addBanksCards.desc',
        'privacyhub.home.otherssee.addBanksCards.desc2',
      ],
      id: 'addBanksCards',
      svg_icon: {
        class: `privacy_hub_image_icon_container`,
        src: getSvgUrl(icon.addCardBlueIcon),
        alt: 'privacy-hub-other-buywithpaypal-image',
        order: 2,
      },
    },
    //Brazil
    {
      enabled: isFeatureEnabled('enabledAddBankCardsBrazil'),
      subheading: {
        size: 'sm',
        class: privacyHubTextClass,
        id: 'addBankCardsBRTitle',
        messageId: 'privacyhub.home.otherssee.addBanksCardsBR.title',
      },
      heading: {
        size: 'lg',
        class: `${privacyHubTextClass} privacy-hub-card-heading`,
        id: 'addBankCardsBRHeading',
        messageId: 'privacyhub.home.otherssee.linkBank,',
      },
      lists: [
        'privacyhub.home.otherssee.addBanksCardsBR.desc',
        'privacyhub.home.otherssee.addBanksCardsBR.desc2',
      ],
      id: 'addBanksCards',
      svg_icon: {
        class: `privacy_hub_image_icon_container`,
        src: getSvgUrl(icon.addCardBlueIcon),
        alt: 'privacy-hub-other-addBanksCards-image',
      },
    },
  ],
}

export const businessPageConfig = {
  fqs: [
    //Gobal
    {
      enabled: isFeatureNotEnabled('disabledDatacontrollerGlobal'),
      title: 'privacyhub.business.faq.datacontroller.title',
      desc1: 'privacyhub.buisiness.faq.desc1',
      desc2: 'privacyhub.buisiness.faq.desc2',
      desc3: 'privacyhub.buisiness.faq.desc3',
      id: 'privacyhubBusinessPageDataController',
    },
    //Brazil
    {
      enabled: isFeatureEnabled('enabledDatacontrollerBrazil'),
      title: 'privacyhub.business.faqBR.datacontroller.title',
      desc1: 'privacyhub.buisiness.faqBR.desc1',
      desc2: 'privacyhub.buisiness.faqBR.desc2',
      desc3: 'privacyhub.buisiness.faqBR.desc3',
      id: 'privacyhubBusinessPageDataController',
    },
    {
      enabled: true,
      title: 'privacyhub.business.faq.dataprotection.title',
      desc1: 'privacyhub.business.faq.dataprotection.desc1',
      id: 'privacyhubBusinessPageDdataProtection',
    },
    {
      enabled: true,
      title: 'privacyhub.business.faq.datareceive.title',
      desc1: 'privacyhub.business.faq.datareceive.desc1',
      desc2: 'privacyhub.business.faq.datareceive.desc2',
      desc3: 'privacyhub.business.faq.datareceive.desc3',
      id: 'privacyhubBusinessPageDataProtection',
    },
  ],
}
export const principlesConfig = {
  KeyTakeaways: [
    {
      icon: {
        name: icon.resolutionIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title1',
      description: 'privacyhub.principles.mainlink.desc1',
      id: 'management',
    },
    {
      icon: {
        name: icon.viewIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title2',
      description: 'privacyhub.principles.mainlink.desc2',
      id: 'noticeAndTransparency',
    },
    {
      icon: {
        name: icon.termsIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title3',
      description: 'privacyhub.principles.mainlink.desc3',
      id: 'choiceAndConsent',
    },
    {
      icon: {
        name: icon.documentIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title4',
      description: 'privacyhub.principles.mainlink.desc4',
      id: 'collection',
    },
    {
      icon: {
        name: icon.informationIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title5',
      description: 'privacyhub.principles.mainlink.desc5',
      id: 'useAndDisposal',
    },
    {
      icon: {
        name: icon.shareIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title6',
      description: 'privacyhub.principles.mainlink.desc6',
      id: 'sharingAndTransfer',
    },
    {
      icon: {
        name: icon.letterCheckmarkIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title7',
      description: 'privacyhub.principles.mainlink.desc7',
      id: 'accessAndQuality',
    },
    {
      icon: {
        name: icon.securityIcon,
        size: 'md',
        color: blueIconClass,
        class: iconClass,
      },
      title: 'privacyhub.principles.mainlink.title8',
      description: 'privacyhub.principles.mainlink.desc8',
      id: 'security',
    },
  ],
  horizantalCardsConfig: [
    {
      svg_icon: {
        class: svgCardClass,
        src: getSvgUrl(icon.protectionBlueIcon),
        alt: 'protection',
      },
      id: 'info_need',
      title: 'privacyhub.principles.card.desc1',
    },
    {
      svg_icon: {
        class: svgCardClass,
        src: getSvgUrl('transparency-blue'),
        alt: 'transparency',
      },
      id: 'info_usage',
      title: 'privacyhub.principles.card.desc2',
      alt: 'transparency',
    },
    {
      svg_icon: {
        class: svgCardClass,
        src: getSvgUrl('accessible-blue'),
        alt: 'accessible',
      },
      id: 'info_access',
      title: 'privacyhub.principles.card.desc3',
    },
  ],
}

const renderConfig = (config, type, props) => {
  switch (type) {
    case 'Heading':
      config.heading.size = 'hero'
      config.order = 1
      config.asset.icon_svg_link = true
      return config
    case 'Main_Links':
      config.cols = 12
      config.asset.cols = 12
      config.order = 2
      config.asset.component_icon = true
      return config
    case 'Card_section':
      config.cols = props?.colAlign ? 6 : 12
      config.order = props?.order ?? 2
      if (!props.heading) {
        config.heading = null
      }
      config.asset.icon_svg_link = true
      config.asset.cols = props?.colAlign ? 6 : 12
      config.asset.order = props?.order === 1 ? 2 : 1
      return config
    case 'Toggle_section':
      config.cols = 8
      config.order = props.order
      if (!props.heading) {
        config.heading = null
      }
      config.asset.icon_svg_link = true
      config.asset.cols = 4
      config.asset.order = props.order === 1 ? 2 : 1
      return config
    default:
      return config
  }
}

export const constructConfigForSection = (type, props) => {
  const { section } = JSON.parse(JSON.stringify(homeConfig))

  if (
    props?.description ||
    props?.descriptionLink ||
    props?.descriptionList ||
    props?.title ||
    props?.subHeading ||
    props?.component_icon ||
    props?.icon_svg_link ||
    props?.Content
  ) {
    section.descriptionList = !props?.descriptionList
      ? [
          {
            description: {
              ...section.descriptionList[0].description,
              ...props.description,
            },
            descriptionLink: props?.descriptionLink
              ? {
                  ...section.descriptionList[0].descriptionLink,
                  ...props.descriptionLink,
                }
              : section.descriptionList[0].descriptionLink,
          },
        ]
      : props?.descriptionList

    section.title = props?.title

    section.Content = props?.Content ?? ''

    section.heading = props.heading
      ? {
          ...section.heading,
          ...props.heading,
        }
      : section.heading

    section.subHeading = props?.subHeading

    section.asset = {
      ...section.asset,
      ...(props?.component_icon??{}),
      ...(props?.icon_svg_link??{}),
    }


    return renderConfig(section, type, props)
  }
  return section
}

export const directionality = locality.directionality || ''